import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const LAST_SEEN_KEY = 'crm_last_seen_announcement_id';

const TYPE_LABELS = {
  update: { label: 'Güncelleme', icon: '🚀' },
  announcement: { label: 'Duyuru', icon: '📢' }
};

// Yönetim panelinden girilen yeni duyuru/güncellemeleri, her kullanıcıya
// tarayıcı başına (localStorage - sunucuda ayrı bir "okundu" tablosu
// kasıtlı olarak yok, basit tutuldu) SADECE BİR KEZ popup olarak gösterir.
// En son görülen id'den daha yeni olan TÜM kayıtlar (arada birden fazla
// eklenmiş olabilir) tek popup'ta listelenir.
const AnnouncementPopup = () => {
  const [items, setItems] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const token = localStorage.getItem('crm_token');
        if (!token) return;
        const { data } = await axios.get('/api/announcements', { headers: { Authorization: `Bearer ${token}` } });
        const all = Array.isArray(data) ? data : [];
        if (all.length === 0) return;

        const lastSeenId = parseInt(localStorage.getItem(LAST_SEEN_KEY), 10) || 0;
        const unseen = all.filter(a => a.id > lastSeenId);
        if (unseen.length > 0) {
          setItems(unseen);
          setVisible(true);
        }
      } catch (err) {
        console.error('AnnouncementPopup fetch error:', err);
      }
    };
    check();
  }, []);

  const handleClose = () => {
    if (items.length > 0) {
      const maxId = Math.max(...items.map(i => i.id));
      localStorage.setItem(LAST_SEEN_KEY, String(maxId));
    }
    setVisible(false);
  };

  if (!visible || items.length === 0) return null;

  return (
    <div className="ap-overlay" onClick={handleClose}>
      <div className="ap-modal" onClick={e => e.stopPropagation()}>
        <div className="ap-header">
          <h2>🎉 Yenilikler</h2>
          <button className="ap-close" onClick={handleClose}>×</button>
        </div>
        <div className="ap-body">
          {items.map(item => {
            const t = TYPE_LABELS[item.type] || TYPE_LABELS.update;
            return (
              <div key={item.id} className="ap-item">
                <div className="ap-item-header">
                  <span>{t.icon}</span>
                  <h3>{item.title}</h3>
                </div>
                <p>{item.content}</p>
                <span className="ap-date">{format(new Date(item.created_at), 'd MMMM yyyy', { locale: tr })}</span>
              </div>
            );
          })}
        </div>
        <div className="ap-footer">
          <button className="btn btn-primary" onClick={handleClose}>Anladım</button>
        </div>
      </div>

      <style>{`
        .ap-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,0.7); backdrop-filter: blur(6px);
          display: flex; align-items: center; justify-content: center; z-index: 2000; padding: 20px;
        }
        .ap-modal {
          background: #13131a; border: 1px solid rgba(255,255,255,0.1); border-radius: 20px;
          width: 100%; max-width: 480px; max-height: 80vh; overflow: hidden;
          display: flex; flex-direction: column; box-shadow: 0 24px 60px rgba(0,0,0,0.6);
        }
        .ap-header { display: flex; justify-content: space-between; align-items: center; padding: 20px 24px; border-bottom: 1px solid rgba(255,255,255,0.07); }
        .ap-header h2 { margin: 0; font-size: 20px; color: #fff; }
        .ap-close { background: none; border: none; font-size: 28px; color: #6B7280; cursor: pointer; line-height: 1; }
        .ap-close:hover { color: #F87171; }
        .ap-body { padding: 20px 24px; overflow-y: auto; display: flex; flex-direction: column; gap: 18px; }
        .ap-item-header { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
        .ap-item-header h3 { margin: 0; font-size: 15px; font-weight: 700; color: #fff; }
        .ap-item p { margin: 0; font-size: 13.5px; color: #D1D5DB; line-height: 1.6; white-space: pre-wrap; }
        .ap-date { display: block; margin-top: 6px; font-size: 11px; color: #6B7280; }
        .ap-footer { padding: 16px 24px; border-top: 1px solid rgba(255,255,255,0.07); display: flex; justify-content: flex-end; }
      `}</style>
    </div>
  );
};

export default AnnouncementPopup;
